import { useCallback } from "react";
import { useRequest } from "ahooks";
import { Menu, Checkbox } from "antd";
import { department as departmentService } from "@/services";

function TypeList({ types = [], type, setType, token, role, onChange }) {
  const { data = [] } = useRequest(
    () =>
      departmentService.listType(
        { type: role.role === "admin" ? 1 : 2 },
        token.token
      ),
    {
      ready: !!token,
      refreshDeps: [token, role],
    }
  );
  const clickHandler = useCallback(
    (value) => {
      setType(value);
    },
    [setType]
  );

  const onChangeHandler = useCallback(
    (id, name, checked) => {
      onChange(id, name, checked);
    },
    [onChange]
  );
  const menuItems = data.map((menu) => {
    const checked = types.find((v) => v.id === menu.id);
    return (
      <Menu.Item key={`department-type-${menu.id}`}>
        <Checkbox
          checked={checked}
          onChange={(e) => {
            e.stopPropagation();
            onChangeHandler(menu.id, menu.name, e.target.checked);
          }}
        />{" "}
        <span onClick={() => clickHandler(menu.id)}>{menu.name}</span>
      </Menu.Item>
    );
  });
  return (
    <Menu defaultSelectedKeys={[`department-type-${type}`]}>
      <Menu.Item
        key={`department-type-all`}
        onClick={() => clickHandler("all")}
      >
        全部
      </Menu.Item>
      {menuItems}
    </Menu>
  );
}

export default TypeList;
